import { LocaleId } from '@portfolio/configs'
import { groq } from 'next-sanity'
import {
  createMediaProjection,
  SELECTED_STATIC_RENDITION,
} from '../projections/createMediaProjection'

export const createSectionMediaProjection = (localeId: LocaleId) => {
  const MEDIA_PROJECTION = createMediaProjection(localeId)

  return groq`{
        _key,
        _type,
        media[] {
          _type == 'media' => ${MEDIA_PROJECTION},
          _type == 'mux.video' => {
            ...asset -> {
              "playbackId": data.playback_ids[0].id,
              "firstFrame": "https://image.mux.com/" + data.playback_ids[0].id + "/thumbnail.jpg?time=0",
              ...(${SELECTED_STATIC_RENDITION()}{width, height}),
            }
          }
        }[0],
      }
  `
}
